/* unplugin-vue-components disabled */import { render } from "./w-standard-button.vue?vue&type=template&id=83b7832c&scoped=true&ts=true"
import script from "./w-standard-button.vue?vue&type=script&lang=ts"
export * from "./w-standard-button.vue?vue&type=script&lang=ts"

import "./w-standard-button.vue?vue&type=style&index=0&id=83b7832c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-83b7832c"]])

export default __exports__